import { memo, useMemo } from 'react';
import { Team } from '../constants/Team';
import { generateTestId, generateTestIdProps } from '../utils';
import { Provider } from './testIdContext';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Test ID provider
 * @param { FC<TestIdProviderProps> } props - Props for configuring the test ID provider
 * @throws { Error } Throws an error if `team` is not provided or is invalid
 * @returns { JSX.Element }
 */
const TestIdProvider = /*#__PURE__*/memo(({
  children,
  team,
  project
}) => {
  if (!team) {
    throw new Error("Property `team` wasn't provided. Test id cannot be generated without it.");
  }
  if (process.env.NODE_ENV !== 'production' && !Object.keys(Team).includes(team)) {
    throw new Error(`Provided team '${team}' isn't allowed. Please select predefined team.`);
  }
  const getTestId = useMemo(() => generateTestId({
    team,
    project
  }), [team, project]);
  const getTestIdProps = useMemo(() => generateTestIdProps({
    team,
    project
  }), [team, project]);
  return /*#__PURE__*/_jsx(Provider, {
    value: {
      getTestId,
      getTestIdProps
    },
    children: children
  });
});
export default TestIdProvider;
//# sourceMappingURL=TestIdProvider.js.map